import React, { useEffect, useState } from "react";
import { downloadFiles, STORAGE_RESET } from "../actions/storage";
import { useAppDispatch, useAppSelector } from "../hooks";
import { BtnWrapper } from "../styles/Docs/DocsToolbar.styled";
//import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { SaveIcon } from "../../public/icons/index";
import { useMediaQuery } from "react-responsive";

import { CircularProgress } from "@mui/material";
import { AlertTooltip } from "./Spreadsheet/ModTooltip";

export default function DownloadButton(props: DownloadButtonProps) {
  const dispatch = useAppDispatch();
  const storage = useAppSelector((state) => state.storage);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 991 });

  useEffect(() => {
    if (storage.state === "failure") {
      setTooltipOpen(true);
      setTimeout(() => setTooltipOpen(false), 2000);
      const timeout = setTimeout(() => {
        dispatch({ type: STORAGE_RESET });
      }, 4000);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [storage]);

  const onHover = () => {
    if (!isMobile) {
      setTooltipOpen(true);
      }
  };

  const onClose = () => {
    if (storage.state === "failure") {
      setTimeout(() => setTooltipOpen(false), 2000);
    } else {
      setTooltipOpen(false);
    }
  }

  const disable =   !props.selectedDocs?.length ||
    storage.state === "loading" ||
    props.cancelledDoc ||
    props.doc?.error?.code === 115;

  return (
    <React.Fragment>
      <AlertTooltip
        open={tooltipOpen}
        id={storage.state === "failure" ? "failure" : "idle"}
        title={
          storage.state === "failure" &&
            "Помилка завантаження документа"
        }
      >
        <span>
          <BtnWrapper
            $bgColor={props.bgColor}
            $widthMob="30px"
            $color={props.$color}
            $width="47px"
            disabled={ disable  }
            onClick={() =>
              dispatch(
                downloadFiles(props.selectedDocs, props.type, props.token),
              )
            }
            onMouseEnter={onHover} onMouseLeave={onClose}
          >
            {storage.state === "loading" ? (
              <CircularProgress size={24} sx={{ color: "var(--white)" }} />
            ) : (
              <span>
                <SaveIcon
                color={!disable
                  ? "var(--blue)"
                : "var(--disabled-c)"}
              />
              </span>
            //<div>Зберегти</div>
            )}
          </BtnWrapper>
        </span>
      </AlertTooltip>
    </React.Fragment>
  );
}
